import React, { useState, useEffect } from 'react'
import { Popover } from 'antd'
import {  useQiyeyhzhUpdateQuery } from '../../store/DianShangYeWuApi';      
function AccountCheck(props) {
    const name = props.name || '';
    // 截取前6个字符（支持汉字和英文混合）
    const trimmed = name.length > props.trimLength ? name.slice(0, props.trimLength) + '…' : name;
    const [open, setOpen] = useState(false);
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };
    const hide = () => {
        setOpen(false);
    };
    const [info,setInfo] = useState({
        name: name,
        trimmed: trimmed,
    });
    const { data, isSuccess } = useQiyeyhzhUpdateQuery({qyyhzh_id:props.qyyhzh_id},{skip: !open, refetchOnMountOrArgChange: 1});
    useEffect(() => {
        if (isSuccess) {
            setInfo(data.Result);
        }
    }, [data, isSuccess]);
    const content = (
        <div>
            <p><b>账户全称：</b>{info.qyyhzh_full_name}</p>
            <p><b>开户银行：</b>{info.qyyhzh_firm}</p>
            <p><b>银行账号：</b>{info.qyyhzh_code}</p>
            <p><b>备注：</b>{info.qyyhzh_content}</p>
            <a onClick={hide}>关闭</a>
        </div>
    )
    return (
        <Popover
            content={content}            
            trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
        >
            <a>{trimmed}</a>
        </Popover>
    )
}

export default AccountCheck